export default __webpack_public_path__ + "static/media/icon-empty-comms.8b0ca64c.svg";